<template>
  <div class="card-form pt-1">
    <PageTable
      ref="table"
      :loading="loading"
      :tableData="tableData"
      @reload="getData"
      @radio-change="(e) => $emit('radio-change', e)"
    >
    </PageTable>
  </div>
</template>
<script>
import PageTable from './table.vue'
import { request } from '@/api/service'
export default {
  components: { PageTable },
  props: {},
  data() {
    return { loading: false, tableData: [] }
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      this.loading = true

      const res = await request({
        url: '/master/common/dict/biz',
        data: { dictType: 'fabricUse' },
        method: 'POST',
      })
      this.loading = false
      if (res.body.data) {
        this.tableData = res.body.data || []
      }
    },
  },
}
</script>
